jQuery.noConflict();jQuery(document).ready(function(){"use strict";


  function handleButtonState() {
      var size = jQuery('input[name="text_safefit_conf"]:checked').val();
      var color_fabric = jQuery('input[name="color_fabric"]:checked').val();
      var side = jQuery('input[name="color_side"]:checked').val();
      var col = jQuery('input[name="color_binding"]:checked').val();
      var belt = jQuery('input[name="color_belt"]:checked').val();
      var puller = jQuery('input[name="puller_options"]:checked').val();
      var zipper = jQuery('input[name="zipper_options"]:checked').val();
      var swaro_back = jQuery('input[name="swarovski_options_back"]:checked').val();
      var swaro_back = jQuery('input[name="swarovski_options_back"]:checked').val();
      var existingImg = jQuery('.preview-image');
      var swaro_front = [];
      jQuery('input[name="swarovski_options[]"]:checked').each(function(){
          swaro_front.push(jQuery(this).val());
      });
      var drapeau = jQuery('.pocket_flag input').val();
      if (existingImg.length > 0) {
        var logo = existingImg.attr('src');
      }
      var htmlContent = `
      <div class="config-resume">
          <p class="config-rese-title">Resume options Configurateur: </p>
          <div class="variation">
              <p class="config-rese-option">Tailles: <span>${size}</span</p>
              <p class="config-rese-option">Couleur tissus principal: <span>${color_fabric}</span></p>
              <p class="config-rese-option">Couleur mesh latéral: <span>${side}</span></p>
              <p class="config-rese-option">Couleur liserés tour de cou: <span>${col}</span></p>
              <p class="config-rese-option">Couleur liserés épaules et hanches: <span>${belt}</span></p>
              <p class="config-rese-option">Fermeture éclair: <span>${zipper}</span></p>
              <p class="config-rese-option">Strass Avant: <span>${swaro_front.join(', ')}</span></p>
              <p class="config-rese-option">Strass Arrière: <span>${swaro_back}</span></p>
              <p class="config-rese-option">Votre drapeau: <span>${drapeau}</span></p>
              <p class="config-rese-option">Logo: ${logo ? ` <img style="height: 3vw;"src="${logo}"/>` : ' <span>Aucun</span>'}</p>
              <p class="config-rese-info">Texte copié dans le presse-papiers</p>
              <p class="btn-popup">OK</p>
          </div>
      </div>`;
      var resumePhrase = `Résumé des options de votre airbag: Tailles: ${size}, Couleur tissus principal: ${color_fabric}, Couleur mesh latéral: ${side}, Couleur liserés tour de cou: ${col}, Couleur liserés épaules et hanches: ${belt}, Fermeture éclair: ${zipper}, Strass Avant: ${swaro_front.join(', ')}, Strass Arrière: ${swaro_back}, Drapeau: ${drapeau}, Logo: ${logo ?  "Oui" : "Aucun"}`;
      jQuery('#resume_input').val(resumePhrase);
      jQuery('div.resume-data').html(htmlContent);
  }
  function copyHiddenInputText() {
      var hiddenInput = document.getElementById("resume_input");
      var tempInput = document.createElement("textarea");
      tempInput.value = hiddenInput.value;
      document.body.appendChild(tempInput);
      tempInput.select();
      tempInput.setSelectionRange(0, 99999); // For mobile devices
    
      if (navigator.clipboard) {
        navigator.clipboard.writeText(tempInput.value).then(function() {
          // alert("Text copied to clipboard: " + tempInput.value);
        }).catch(function(err) {
          console.error("Could not copy text: ", err);
        });
      } else {
        document.execCommand("copy");
        // alert("Text copied to clipboard: " + tempInput.value);
      }
    
      document.body.removeChild(tempInput);
  }
  jQuery('#copy-config').click(function(){
      handleButtonState();
      copyHiddenInputText();
      jQuery('div.resume-data').addClass('active');
  });
  handleButtonState();
  jQuery(document).on('click', '.configurateur-img-container .btn-popup', function() {
      jQuery('div.resume-data').removeClass('active');
  });
  jQuery('input[name="text_safefit_conf"]').change(function() {
    handleButtonState();
  });
  jQuery('input[name="color_fabric"]').change(function() {
    jQuery('.btn-front').trigger('click');
    var selectedValue = jQuery('input[name="color_fabric"]:checked').val().toLowerCase();
    jQuery('img[class^="img-config main-color"]').removeClass('active');
    jQuery('.img-config.main-color-'+selectedValue).addClass('active');
    jQuery('img[class^="img-config back-main-color"]').removeClass('active');
    jQuery('.img-config.back-main-color-'+selectedValue).addClass('active');
    handleButtonState();
  });
  jQuery('input[name="color_side"]').change(function() {
    jQuery('.btn-front').trigger('click');
    var selectedValue = jQuery('input[name="color_side"]:checked').val().toLowerCase();
    var fabric = 'mesh';
    if( fabric == 'mesh'){
      jQuery('img[class^="img-config side-color"]').removeClass('active');
      jQuery('img[class^="img-config back-side-color"]').removeClass('active');
  
      jQuery('img[class^="img-config side-mesh"]').removeClass('active');
      jQuery('img[class^="img-config back-side-mesh"]').removeClass('active');
      jQuery('.img-config.side-mesh-top').addClass('active');
      jQuery('.img-config.side-mesh-'+selectedValue).addClass('active');
      jQuery('.img-config.back-side-mesh-'+selectedValue).addClass('active');
    } else {
      if(selectedValue == 'aucun'){
        jQuery('img[class^="img-config side-color"]').removeClass('active');
        jQuery('img[class^="img-config back-side-color"]').removeClass('active');
      }else {
        jQuery('img[class^="img-config side-color"]').removeClass('active');
        jQuery('.img-config.side-color-'+selectedValue).addClass('active');
        jQuery('img[class^="img-config back-side-color"]').removeClass('active');
        jQuery('.img-config.back-side-color-'+selectedValue).addClass('active');
  
        jQuery('img[class^="img-config side-mesh"]').removeClass('active');
        jQuery('img[class^="img-config back-side-mesh"]').removeClass('active');
      }
    }
    handleButtonState();
  });
  jQuery('input[name="fabric"]').change(function() {
    jQuery('.btn-front').trigger('click');
    var selectedValue = jQuery('input[name="fabric"]:checked').val().toLowerCase();
    var color = jQuery('input[name="color_side"]:checked').val().toLowerCase();
    if(selectedValue == 'mesh'){
      jQuery('.img-config.side-laser').removeClass('active');
      jQuery('.img-config.side-oval').removeClass('active');
      
      jQuery('.img-config.back-laser').removeClass('active');
      jQuery('.img-config.back-opal').removeClass('active');
      
      jQuery('img[class^="img-config side-color"]').removeClass('active');
      jQuery('img[class^="img-config back-side-color"]').removeClass('active');
      jQuery('img[class^="img-config side-mesh"]').removeClass('active');
      jQuery('img[class^="img-config back-side-mesh"]').removeClass('active');
      jQuery('.img-config.side-mesh-top').addClass('active');
      jQuery('.img-config.side-mesh-'+color).addClass('active');
      jQuery('.img-config.back-side-mesh-'+color).addClass('active');
      
    }else if(selectedValue == 'laser dots'){
      jQuery('img[class^="img-config side-mesh"]').removeClass('active');
      jQuery('img[class^="img-config back-side-mesh"]').removeClass('active');
      jQuery('.img-config.side-oval').removeClass('active');
      jQuery('.img-config.side-laser').addClass('active');
      jQuery('.img-config.side-mesh-top').removeClass('active');
      jQuery('.img-config.back-opal').removeClass('active');
      jQuery('.img-config.back-laser').addClass('active');
      jQuery('img[class^="img-config side-color"]').removeClass('active');
        jQuery('.img-config.side-color-'+color).addClass('active');
        jQuery('img[class^="img-config back-side-color"]').removeClass('active');
        jQuery('.img-config.back-side-color-'+color).addClass('active');
    } else {
      jQuery('img[class^="img-config side-mesh"]').removeClass('active');
      jQuery('img[class^="img-config back-side-mesh"]').removeClass('active');
      // jQuery('.img-config.side-mesh').removeClass('active');
      jQuery('.img-config.side-laser').removeClass('active');
      jQuery('.img-config.side-oval').addClass('active');
      // jQuery('.img-config.back-mesh').removeClass('active');
      jQuery('.img-config.side-mesh-top').removeClass('active');
      jQuery('.img-config.back-laser').removeClass('active');
      jQuery('.img-config.back-opal').addClass('active');
      jQuery('img[class^="img-config side-color"]').removeClass('active');
        jQuery('.img-config.side-color-'+color).addClass('active');
        jQuery('img[class^="img-config back-side-color"]').removeClass('active');
        jQuery('.img-config.back-side-color-'+color).addClass('active');
    }
    handleButtonState();
  });
  jQuery('input[name="color_binding"]').change(function() {
    jQuery('.btn-front').trigger('click');
    var selectedValue = jQuery('input[name="color_binding"]:checked').val().toLowerCase().replace(/\s+/g, '-').toLowerCase();
    if(selectedValue == 'aucun'){
      jQuery('img[class^="img-config collar"]').removeClass('active');
    }else {
      jQuery('img[class^="img-config collar"]').removeClass('active');
      jQuery('.img-config.collar-'+selectedValue).addClass('active');
    }
    handleButtonState();
    
  });
  jQuery('input[name="color_belt"]').change(function() {
    jQuery('.btn-back').trigger('click');
    var selectedValue = jQuery('input[name="color_belt"]:checked').val().toLowerCase().replace(/\s+/g, '-').toLowerCase();
      jQuery('img[class^="img-config back-shoulders"]').removeClass('active');
      jQuery('.img-config.back-shoulders-color-'+selectedValue).addClass('active');
      jQuery('img[class^="img-config front-shoulders"]').removeClass('active');
      jQuery('.img-config.front-shoulders-color-'+selectedValue).addClass('active');
    // 
    handleButtonState();
  });
  jQuery('input[name="color_pipings_up"]').change(function() {
    jQuery('.btn-front').trigger('click');
    var selectedValue = jQuery('input[name="color_pipings_up"]:checked').val().toLowerCase().replace(/\s+/g, '-').toLowerCase();;
      jQuery('img[class^="img-config binding-up"]').removeClass('active');
      jQuery('.img-config.binding-up-'+selectedValue).addClass('active');
      handleButtonState();
  });
  jQuery('input[name="color_pipings_down"]').change(function() {
    jQuery('.btn-front').trigger('click');
    var selectedValue = jQuery('input[name="color_pipings_down"]:checked').val().toLowerCase().replace(/\s+/g, '-').toLowerCase();
    jQuery('img[class^="img-config binding-down"]').removeClass('active');
    jQuery('.img-config.binding-down-'+selectedValue).addClass('active');
    handleButtonState();
  });
  jQuery('input[name="puller_options"]').change(function() {
    jQuery('.btn-front').trigger('click');
    var selectedValue = jQuery('input[name="puller_options"]:checked').val().toLowerCase();
    if(selectedValue == 'aucun'){
      jQuery('img[class^="img-config zip"]').removeClass('active');
      jQuery('img[class^="img-config zip-aucun"]').addClass('active');
    }else if(selectedValue == 'gold_ring'){
      jQuery('img[class^="img-config zip"]').removeClass('active');
      jQuery('.img-config.zip-gold-ring').addClass('active');
    }else if(selectedValue == 'gold heart'){
      jQuery('img[class^="img-config zip"]').removeClass('active');
      jQuery('.img-config.zip-gold-heart').addClass('active');
    }else if(selectedValue == 'silver heart'){
      jQuery('img[class^="img-config zip"]').removeClass('active');
      jQuery('.img-config.zip-silver-heart').addClass('active');
    }else if(selectedValue == 'silver_ring'){
      jQuery('img[class^="img-config zip"]').removeClass('active');
      jQuery('.img-config.zip-silver-ring').addClass('active');
    }
    else if(selectedValue == 'silver_rectangle'){
      jQuery('img[class^="img-config zip"]').removeClass('active');
      jQuery('.img-config.zip-silver-rect').addClass('active');
    }
    else if(selectedValue == 'gold_rectangle'){
      jQuery('img[class^="img-config zip"]').removeClass('active');
      jQuery('.img-config.zip-gold-rect').addClass('active');
    }
    else if(selectedValue == 'matted black'){
      jQuery('img[class^="img-config zip"]').removeClass('active');
      jQuery('.img-config.zip-mat').addClass('active');
    }else if(selectedValue == 'silver'){
      jQuery('img[class^="img-config zip"]').removeClass('active');
      jQuery('.img-config.zip-silver').addClass('active');
    }else if(selectedValue == 'rainbow'){
      jQuery('img[class^="img-config zip"]').removeClass('active');
      jQuery('.img-config.zip-rainbow').addClass('active');
    }else if(selectedValue == 'strass'){
      jQuery('img[class^="img-config zip"]').removeClass('active');
      jQuery('.img-config.zip-strass').addClass('active');
    }else if(selectedValue == 'fake leather'){
      jQuery('img[class^="img-config zip"]').removeClass('active');
      jQuery('.img-config.zip-leather').addClass('active');
    }else if(selectedValue == 'damier'){
      jQuery('img[class^="img-config zip"]').removeClass('active');
      jQuery('.img-config.zip-damier').addClass('active');
    }
    handleButtonState();
  });
  jQuery("label[for='puller_options_Gold_ring']").addClass('btn-disabled');
  jQuery("label[for='puller_options_Gold_rectangle']").addClass('btn-disabled');
  jQuery("label[for='puller_options_Silver_ring']").addClass('btn-disabled');
  jQuery("label[for='puller_options_Silver_rectangle']").addClass('btn-disabled');
  jQuery('input[name="zipper_options"]').change(function() {
      jQuery('.btn-front').trigger('click');
      var selectedValue = jQuery('input[name="zipper_options"]:checked').val().toLowerCase();
      jQuery('img[class^="img-config puller"]').removeClass('active');
      if(selectedValue == 'aucun'){
        jQuery('img[class^="img-config puller"]').removeClass('active');
        jQuery("table.extra-options.thwepo_zip_puller label.radio").removeClass("disabled");
        jQuery('input#puller_options_Aucun').trigger("click");
        jQuery("label[for='puller_options_Gold_ring']").addClass('btn-disabled');
        jQuery("label[for='puller_options_Gold_rectangle']").addClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_ring']").addClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_rectangle']").addClass('btn-disabled');
      }else if(selectedValue == 'black mat'){
        jQuery('.img-config.puller-mat').addClass('active');
        jQuery("table.extra-options.thwepo_zip_puller label.radio").removeClass("disabled");
        jQuery("label[for='puller_options_Gold_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Gold_rectangle']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_rectangle']").removeClass('btn-disabled');
      }else if(selectedValue == 'black shiny'){
        jQuery('.img-config.puller-shiny').addClass('active');
        jQuery("table.extra-options.thwepo_zip_puller label.radio").removeClass("disabled");
        jQuery("label[for='puller_options_Gold_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Gold_rectangle']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_rectangle']").removeClass('btn-disabled');
      }else if(selectedValue == 'gold'){
        jQuery('.img-config.puller-gold').addClass('active');
        jQuery("table.extra-options.thwepo_zip_puller label.radio").removeClass("disabled");
        jQuery("label[for='puller_options_Gold_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Gold_rectangle']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_rectangle']").removeClass('btn-disabled');
      }else if(selectedValue == 'silver'){
        jQuery('.img-config.puller-silver').addClass('active');
        jQuery("table.extra-options.thwepo_zip_puller label.radio").removeClass("disabled");
        jQuery("label[for='puller_options_Gold_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Gold_rectangle']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_rectangle']").removeClass('btn-disabled');
      }else if(selectedValue == 'gold full'){
        jQuery('.img-config.puller-gold-full').addClass('active');
        jQuery("table.extra-options.thwepo_zip_puller label.radio").removeClass("disabled");
        jQuery("label[for='puller_options_Gold_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Gold_rectangle']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_rectangle']").removeClass('btn-disabled');
      }else if(selectedValue == 'silver full'){
        jQuery('.img-config.puller-silver-full').addClass('active');
        jQuery("table.extra-options.thwepo_zip_puller label.radio").removeClass("disabled");
        jQuery("label[for='puller_options_Gold_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Gold_rectangle']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_rectangle']").removeClass('btn-disabled');
      }else if(selectedValue == 'white'){
        jQuery('.img-config.puller-white').addClass('active');
        jQuery("table.extra-options.thwepo_zip_puller label.radio").removeClass("disabled");
        jQuery("label[for='puller_options_Gold_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Gold_rectangle']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_rectangle']").removeClass('btn-disabled');
      }else if(selectedValue == 'bbr'){
        jQuery('.img-config.puller-bbr').addClass('active');
        jQuery("table.extra-options.thwepo_zip_puller label.radio").removeClass("disabled");
        jQuery("table.extra-options.thwepo_zip_puller label.radio:not([for='puller_options_Aucun'])").addClass("disabled");
        jQuery("label[for='puller_options_Gold_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Gold_rectangle']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_rectangle']").removeClass('btn-disabled');
      }else if(selectedValue == 'rainbow'){
        jQuery('.img-config.puller-rainbow').addClass('active');
        jQuery("table.extra-options.thwepo_zip_puller label.radio").removeClass("disabled");
        jQuery("label[for='puller_options_Gold_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Gold_rectangle']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_rectangle']").removeClass('btn-disabled');
      }else if(selectedValue == 'cooper'){
        jQuery('.img-config.puller-cooper').addClass('active');
        jQuery("table.extra-options.thwepo_zip_puller label.radio").removeClass("disabled");
        jQuery("label[for='puller_options_Gold_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Gold_rectangle']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_rectangle']").removeClass('btn-disabled');
      } else if(selectedValue == 'seaver'){
        jQuery('.img-config.puller-seaver').addClass('active');
        jQuery("table.extra-options.thwepo_zip_puller label.radio:not([for='puller_options_Aucun'])").addClass("disabled");
        jQuery("label[for='puller_options_Gold_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Gold_rectangle']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_ring']").removeClass('btn-disabled');
        jQuery("label[for='puller_options_Silver_rectangle']").removeClass('btn-disabled');
      }
      handleButtonState();
  });
  
  function observeNameChange(classSelector) {
      const inputElement = jQuery(classSelector);
      inputElement.on('input', function() {
        const newValue = jQuery(this).val();
        jQuery('.pocket-name p').text(newValue);
      });
  }
  function observeFlagChange(classSelector) {
      const divElement = jQuery(classSelector);
      const observer = new MutationObserver(function(mutationsList, observer) {
        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              var clonedDiv = jQuery('.selected-flag .flag').clone();
              jQuery('.pocket-flag .country-select').empty().append(clonedDiv);
          }
        }
      });
      observer.observe(divElement[0], { attributes: true });
  }
    
  jQuery(".section-title").append('<span class="expand-btn"></span>')
  jQuery('tr.pocket_aucun input').prop("checked", true).prop("disabled",false);
  jQuery('tr.pocket_strass input').prop("checked", false).prop("disabled",true);
  jQuery('tr.pocket_name input').removeClass('sel');
  jQuery('tr.pocket_name input').addClass('not-sel');
  
  jQuery('body').on('click', 'tr.pocket_name', function() {
    if(!jQuery('tr.pocket_name input').hasClass('sel')){
      
      jQuery('tr.pocket_name input').addClass('sel');
      jQuery('tr.pocket_name input').removeClass('not-sel');
  
      jQuery('.pocket-attrib.pocket-flag').removeClass('hide-it');
      var clonedDiv = jQuery('.selected-flag .flag').clone();
      jQuery('.pocket-flag .country-select').empty().append(clonedDiv);
      observeFlagChange('.flag-dropdown .selected-flag .flag');
      jQuery('tr.pocket_flag input').removeClass('not-sel');
      jQuery('tr.pocket_flag input').val('France').prop("disabled",false);
      jQuery('tr.pocket_flag input').addClass('sel');
      jQuery('tr.pocket_aucun input').prop("checked", false).prop("disabled",true);
  
      observeNameChange('tr.pocket_name input');
    }
  });

  jQuery(document).ready(function() {
    jQuery('input#logocustom').attr('accept', '.png, .svg');
  });
  
  jQuery('input#logocustom').on('change', function(event) {
      var allowedExtensions = ['png', 'svg'];
      var file = this.files[0];
      if (file) {
        var fileName = file.name;
        var fileExtension = fileName.split('.').pop().toLowerCase();
        if (allowedExtensions.indexOf(fileExtension) === -1) {
          this.value = ''; // Clear the input
          jQuery('.thwepo-preview-file').empty();
          alert('Invalid file type. Only .png and .svg files are allowed.');
          
        }else {
          var imageUrl;
          if (window.URL) {
              imageUrl = window.URL.createObjectURL(file);
              jQuery('tr.options-data.custom-logo-input-container td.label').addClass('uploaded');
              jQuery('tr.options-data.custom-logo-input-container td.value').addClass('uploaded');
          } else if (window.webkitURL) {
              imageUrl = window.webkitURL.createObjectURL(file);
              jQuery('tr.options-data.custom-logo-input-container td.label').addClass('uploaded');
              jQuery('tr.options-data.custom-logo-input-container td.value').addClass('uploaded');
          }
            // Check if there is already an image preview
            var existingImg = jQuery('.preview-image');
            var existingPocketImg = jQuery('.pocket-custom');
            if (existingImg.length > 0) {
                // If an image preview already exists, update its src attribute
                existingImg.attr('src', imageUrl);
            } else {
                // If no image preview exists, create a new <img> element
                var imgElement = jQuery('<img>').attr('src', imageUrl).addClass('preview-image');
                // Insert the <img> element after the div with class .thwepo-preview-file
                jQuery('.thwepo-preview-file').append(imgElement);
                jQuery('.thwepo-preview-file').append("<span class='change-uplogo'>Changer l'image</span>");
                jQuery('.thwepo-preview-file').append("<span class='thwepo-uploaded-item'><span class='thwepo-uploaded-file'>"+file.name+"</span></span>");
                jQuery('.custom-logo-input-container td.value').append('<span class="remove-image-custom">X</span>');
            }
            if (existingPocketImg.length > 0) {
                existingPocketImg.attr('src', imageUrl);
            } else {
                var divElement = jQuery('<img class="pocket-custom">').attr('src', imageUrl);
                jQuery('.configurateur-img.configurateur-front').append(divElement);
            }
        }
      }
      handleButtonState();
  });
  jQuery('.custom-logo-input-container').on('click', '.remove-image-custom', function() {
    jQuery('input#logocustom').val('');
    jQuery('tr.options-data.custom-logo-input-container td.label').removeClass('uploaded');
    jQuery('tr.options-data.custom-logo-input-container td.value').removeClass('uploaded');
    jQuery('.preview-image').remove();
    jQuery('.pocket-custom').remove();
    jQuery('.change-uplogo').remove();
    jQuery('.thwepo-uploaded-item').remove();
    jQuery('.remove-image-custom').remove();
  });
  jQuery('form.cart table.extra-options .text-input-container label.radio').contents().filter(function() {
      return this.nodeType === 3 && !jQuery(this).parent().is('input');
  }).wrap('<div></div>');
  jQuery('tr.pocket_aucun label.radio').contents().filter(function() {
      return this.nodeType === 3 && !jQuery(this).parent().is('input');
  }).wrap('<div></div>');
  jQuery('tr.pocket_strass label.radio').contents().filter(function() {
      return this.nodeType === 3 && !jQuery(this).parent().is('input');
  }).wrap('<div></div>');
  jQuery(".expand-btn").click(function(){
      jQuery('.extra-options').not(jQuery(this).closest('.extra-options')).removeClass('expanded');
      jQuery(this).closest('.extra-options').toggleClass('expanded');
  });
  jQuery(".section-title h3").click(function(){
      jQuery('.extra-options').not(jQuery(this).closest('.extra-options')).removeClass('expanded');
      jQuery(this).closest('.extra-options').toggleClass('expanded');
  });
  jQuery('.btn-front').click(function(){
      jQuery('.btn-front').addClass('active');
      jQuery('.btn-back').removeClass('active');
      jQuery('.configurateur-back').addClass('passive');
      jQuery('.configurateur-front').removeClass('passive');
  });
  jQuery('.btn-back').click(function(){
      jQuery('.btn-back').addClass('active');
      jQuery('.btn-front').removeClass('active');
      jQuery('.configurateur-front').addClass('passive');
      jQuery('.configurateur-back').removeClass('passive');
  });
  if (jQuery(window).width() < 1000) {
      jQuery('table.extra-options input').click(function(){
        jQuery('html, body').stop().animate({
          scrollTop: jQuery(".single-product-container").offset().top - 200
        }, 700);
      });
      
  }
 
  jQuery("#showShare").click(function(){
      jQuery(".share-icon").toggleClass('hid-it');
  });
   
                                                      
  // price sawro front
  var p_front = 299;
  // price swaro back
  var p_back = 499;
  var currencySymbol = jQuery('.woocommerce-Price-currencySymbol').text();
  var priceValue = parseFloat(jQuery('.woocommerce-Price-amount bdi').text().replace(currencySymbol, '').trim());
  var priceValueBack = priceValue + p_back;
  jQuery('table.extra-options.swarovski_sf_container label.checkbox').each(function() {
    var $label = jQuery(this);
    var $la_d = $label.attr("for");
    if($la_d == 'swarovski_options_Strass - Lines 2x' ||$la_d == 'swarovski_options_Strass - down' || $la_d == 'swarovski_options_Strass - Long lines' ) {
    $label.append("<strong> (+ "+ p_front + " " + currencySymbol +")</strong>");
    }
  });
  jQuery('table.extra-options.swarovski_sf_container label.radio').each(function() {
    var $label = jQuery(this);
    var $la_d = $label.attr("for");
    if($la_d == 'swarovski_options_Strass - Lines 4x' ||$la_d == 'swarovski_options_back_Strass - Rain') {
    $label.append("<strong> (+ "+ p_back + " " + currencySymbol +")</strong>");
    }
  });
  jQuery('input[name="swarovski_options[]"]').change(function() {
  
    var selectedSwValues = [];
    jQuery('input[name="swarovski_options[]"]:checked').each(function() {
      selectedSwValues.push(jQuery(this).val().toLowerCase());
    });
    var extra_p = 0;
    if(selectedSwValues.indexOf('strass - full top') !== -1){
    extra_p += p_front;
    jQuery('.img-config.strass-rain').addClass('active');
    jQuery('.btn-front').trigger('click');
    }else{
    jQuery('.img-config.strass-rain').removeClass('active');
    }
    if(selectedSwValues.indexOf('strass - lines 2x') !== -1){
    extra_p += p_front;
    jQuery('.img-config.strass-line-2').addClass('active');
    jQuery('.btn-front').trigger('click');
    }else{
    jQuery('.img-config.strass-line-2').removeClass('active');
    }
    if(selectedSwValues.indexOf('strass - down') !== -1){
    extra_p += p_front;
    jQuery('.img-config.strass-down').addClass('active');
    jQuery('.btn-front').trigger('click');
    }else{
    jQuery('.img-config.strass-down').removeClass('active');
    }
    if(selectedSwValues.indexOf('strass - lines 4x') !== -1){
    extra_p += p_front;
    jQuery('.img-config.strass-line-4').addClass('active');
    jQuery('.btn-front').trigger('click');
    }else{
    jQuery('.img-config.strass-line-4').removeClass('active');
    }
    if(selectedSwValues.indexOf('strass - long lines') !== -1){
    extra_p += p_front;
    jQuery('.img-config.strass-long').addClass('active');
    jQuery('.btn-front').trigger('click');
    }else{
    jQuery('.img-config.strass-long').removeClass('active');
    }
    if(jQuery(this).val() === 'Aucun' && jQuery(this).is(':checked')) {
    jQuery('input[name="swarovski_options[]"]').not(this).prop('checked', false);
    jQuery('img[class^="img-config strass"]').removeClass('active');
    jQuery('.btn-front').trigger('click');
    extra_p = 0;
    } else if (jQuery('input[name="swarovski_options[]"][value="Aucun"]').is(':checked')) {
      jQuery('input[name="swarovski_options[]"][value="Aucun"]').prop('checked', false);
    }
    var priceElement = jQuery(".price-config-container .price .woocommerce-Price-amount bdi");
    var $la_b = jQuery("input[name='swarovski_options_back']:checked").val();
    if ($la_b == 'Aucun'){
    var ori_price = priceValue;
    }
    else{
    var ori_price = priceValueBack;
    }
    var currencySymbol = jQuery('.woocommerce-Price-currencySymbol').text();
    var newTotalPrice = ori_price + extra_p;
    priceElement.html('<span class="woocommerce-Price-currencySymbol">'+currencySymbol + " </span>" + newTotalPrice.toFixed(2));
    handleButtonState();
  });
  jQuery('input[name="swarovski_options_back"]').change(function() {
  
    var extra_cost = 0;
    var selectedValue = jQuery('input[name="swarovski_options_back"]:checked').val().toLowerCase();
    if(selectedValue == 'aucun'){
    jQuery('img[class^="img-config strass"]').removeClass('active');
    jQuery('.img-config.back-strass').removeClass('active');
    jQuery('.btn-back').trigger('click');
    extra_cost = -p_back;
    }
    else if(selectedValue == 'strass - rain'){
    jQuery('img[class^="img-config strass"]').removeClass('active');
    jQuery('.img-config.back-strass').addClass('active');
    jQuery('.btn-back').trigger('click');
    extra_cost = p_back;
    }
    var priceElement = jQuery(".price-config-container .price .woocommerce-Price-amount bdi");
    var currentPrice = parseFloat(priceElement.text().replace(currencySymbol, "").trim());
    var newTotalPrice = currentPrice + extra_cost;
    priceElement.html('<span class="woocommerce-Price-currencySymbol">'+currencySymbol + " </span>" + newTotalPrice.toFixed(2));
    handleButtonState();
  }); 
  
  // add to cart function
    jQuery('.add-to-cart').click(function(){
      
      var variantMapping = {
        "base": "51595087184190",
        "front1": "51595087216958",
        "front2": "51595087249726",
        "front3": "51595087282494",
        "back": "51595087315262",
        "front1_back": "51595087348030",
        "front2_back": "51595087380798",
        "front3_back": "51595087413566"
      };
    
      var size = jQuery('input[name="text_safefit_conf"]:checked').val();
      var color_fabric = jQuery('input[name="color_fabric"]:checked').val();
      var side = jQuery('input[name="color_side"]:checked').val();
      var col = jQuery('input[name="color_binding"]:checked').val();
      var belt = jQuery('input[name="color_belt"]:checked').val();
      var zipper = jQuery('input[name="zipper_options"]:checked').val();
      var swaro_back = jQuery('input[name="swarovski_options_back"]:checked').val();
      var swaro_back = jQuery('input[name="swarovski_options_back"]:checked').val();
      var existingImg = jQuery('.preview-image');
      var swaro_front = [];
      jQuery('input[name="swarovski_options[]"]:checked').each(function(){
          swaro_front.push(jQuery(this).val());
      });
      
          var drapeau = jQuery('.pocket_flag input').val();
          console.log("Drapeau: " + drapeau);
      var logo = existingImg.attr('src');
      var customLogo = logo ? "Yes" : "No";
      console.log("Logo: " + logo);

      var frontOptions = [];
      
      jQuery('input[name="swarovski_options[]"]:checked').each(function() {
          if (jQuery(this).val() !== "Aucun") {
              frontOptions.push(jQuery(this).val());
          }
      });
      var backOption = jQuery('input[name="swarovski_options_back"]:checked').val();
      var hasBackAddon = backOption !== "Aucun";
      // Determine variant key
      var variantKey = "base";
      if (frontOptions.length === 1 && !hasBackAddon) variantKey = "front1";
      if (frontOptions.length === 2 && !hasBackAddon) variantKey = "front2";
      if (frontOptions.length === 3 && !hasBackAddon) variantKey = "front3";
      if (frontOptions.length === 0 && hasBackAddon) variantKey = "back";
      if (frontOptions.length === 1 && hasBackAddon) variantKey = "front1_back";
      if (frontOptions.length === 2 && hasBackAddon) variantKey = "front2_back";
      if (frontOptions.length === 3 && hasBackAddon) variantKey = "front3_back";

      // Get the correct variant ID
      var selectedVariantId = variantMapping[variantKey];
      console.log("Selected Variant ID:", selectedVariantId);
      var properties = {
        "Size": size,
        "Color Fabric": color_fabric,
        "Color Side": side,
        "Binding Color neck": col,
        "Shoulders and Hips": belt,
        "Zipper Option": zipper,
        "Swarovski Front": swaro_front.join(', '),
        "Swarovski Back": swaro_back,
        "Flag": drapeau,
        "CustomLogo": customLogo
      };

      
        // Convert properties into URL parameters
        var propertiesString = "";
        for (var key in properties) {
            if (properties[key]) { // Only add if value exists
                propertiesString += "&properties[" + encodeURIComponent(key) + "]=" + encodeURIComponent(properties[key]);
            }
        }

        // Final URL
        var baseUrl = "https://equisboutique.com/cart/add?id=" + selectedVariantId + "&quantity=1";
        var finalUrl = baseUrl + propertiesString + "&return_to=/cart";
        console.log("Redirecting to: " + finalUrl);
        // Redirect user to the cart with selected options
       window.location.href = finalUrl;
    });
  // end add to cart 
 // download preview function
    document.getElementById('downloadImage').addEventListener('click', async function() {
        const { jsPDF } = window.jspdf; // Import jsPDF from the global scope

        const canvasFront = await html2canvas(document.getElementById("front"), {
          width: 648,
          height: 576,
          // scale: 1
        });

        const canvasBack = await html2canvas(document.getElementById("back"), {
          width: 648,
          height: 576,
          // scale: 1
        });

        const resumeDataElement = document.getElementById("resume-data");
        const clone = resumeDataElement.cloneNode(true);
        // Remove specific elements from the clone
        clone.querySelectorAll('.config-rese-info, .btn-popup').forEach(element => element.remove());
        clone.style.display = 'block'; // Make the clone visible
        clone.style.position = 'absolute';
        clone.style.left = '-9999px'; // Move it off-screen
        document.body.appendChild(clone);

        const canvasResume = await html2canvas(clone, {
          width: 648,
          height: 576,
        });

        document.body.removeChild(clone); // Remove the clone after capturing

        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'px',
          format: [648, 576]
        });

        // Add the first canvas image to the first page
        pdf.addImage(canvasFront.toDataURL('image/png'), 'PNG', 0, 0, 648, 576);

        // Add a new page for the second canvas image
        pdf.addPage();
        pdf.addImage(canvasBack.toDataURL('image/png'), 'PNG', 0, 0, 648, 576);

        // Add another new page for the third canvas (#resume-data)
        pdf.addPage();
        pdf.addImage(canvasResume.toDataURL('image/png'), 'PNG', 0, 0, 648, 576);
        // Save the PDF
        pdf.save('your-seaver-as-you-are.pdf');
    });
  // end download preview

  
});